(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = root.pdfjsImageDecoders = factory();
	else if(typeof define === 'function' && define.amd)
		define("@divriots/pdfjs-dist/image_decoders/pdf.image_decoders", [], factory);
	else if(typeof exports === 'object')
		exports["@divriots/pdfjs-dist/image_decoders/pdf.image_decoders"] = factory();
	else
		root["@divriots/pdfjs-dist/image_decoders/pdf.image_decoders"] = factory();
})(globalThis, () => {
return 